import Store from '../Store/Store';
import Request from '../Request/Request';

export function checkToken( callBack ) {

	const user = Store.get( 'user' )

	if ( !user ) callBack()

	if ( user && user.token ) {
		Request.get( 'token', 
			d => {
				if ( !d.data.token ) { 
					Store.set( 'user', null )
					callBack()
				}
			}, 
			e => { callBack() }
		)
	}

}
